import { render, staticRenderFns } from "./comp_CheckoutStep-contact--done.vue?vue&type=template&id=d7edc5ca"
import script from "./comp_CheckoutStep-contact--done.vue?vue&type=script&lang=js"
export * from "./comp_CheckoutStep-contact--done.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
